export const LABEL_STYLE = { fontWeight: 'normal' };
export const INPUT_STYLE = { height: '40px' };
